import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Native color-picker swatch (`<input type="color">`) used by editor toolbars
 * (floor-plan canvas). Standalone: the parent drives `[value]` and reads the
 * raw events (`$event.target.value`). The compact swatch box styling lives
 * here, centrally.
 */
@Component({
  selector: 'app-color-swatch',
  templateUrl: './color-swatch.component.html',
  styleUrls: ['./color-swatch.component.scss'],
})
export class ColorSwatchComponent {
  @Input() value = '#000000';
  /** Extra class(es) on the input (utility spacing like 'mr-1'). */
  @Input() cssClass = '';

  /** Raw input event (live while dragging in the picker). */
  @Output() inputEvent = new EventEmitter<Event>();
  /** Raw change event (picker committed). */
  @Output() changeEvent = new EventEmitter<Event>();
}
